var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('div',{staticClass:"text-center py-2 alert alert-success"},[_vm._v("\n      You have "),_c('b',[_vm._v(_vm._s(_vm.days_left))]),_vm._v(" free trial days left\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }